import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

export function useLoad(url, params) {
  const [data, setData] = useState(null);
  const key = JSON.stringify(params || {});
  const reload = useCallback(() => api.get(url, { params: JSON.parse(key) }).then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e))), [url, key]);
  useEffect(() => { reload(); }, [reload]);
  return [data, reload];
}

export async function act(fn, ok) {
  try {
    const r = await fn();
    if (ok) toast.success(ok);
    return r?.data ?? true;
  } catch (e) {
    toast.error(errMsg(e));
    return null;
  }
}

export const Card = ({ title, right, children, className = "", testid }) => (
  <div className={`admin-card p-6 ${className}`} data-testid={testid}>
    {(title || right) && <div className="flex items-center justify-between mb-4"><div className="label-xs">{title}</div>{right}</div>}
    {children}
  </div>
);

export const Stat = ({ label, value, sub, tone = "", testid, title }) => (
  <div className="admin-card p-5" data-testid={testid} title={title}>
    <div className="label-xs">{label}</div>
    <div className={`font-mono text-2xl mt-2 ${tone}`}>{value}</div>
    {sub && <div className="text-[11px] text-slate-500 mt-1">{sub}</div>}
  </div>
);

const TONES = {
  published: "text-emerald-400 border-emerald-400/30", approved: "text-cyan-400 border-cyan-400/30", pending_review: "text-amber-400 border-amber-400/30",
  rejected: "text-red-400 border-red-400/30", suspended: "text-red-300 border-red-300/30", success: "text-emerald-400 border-emerald-400/30",
  failed: "text-red-400 border-red-400/30", blocked: "text-amber-400 border-amber-400/30", running: "text-cyan-400 border-cyan-400/30",
  active: "text-emerald-400 border-emerald-400/30", paused: "text-amber-400 border-amber-400/30", escalated: "text-amber-400 border-amber-400/30",
  customer_refunded: "text-emerald-400 border-emerald-400/30", paid: "text-emerald-400 border-emerald-400/30", delivered: "text-emerald-400 border-emerald-400/30",
  simulated: "text-fuchsia-300 border-fuchsia-300/30", high: "text-red-400 border-red-400/30", medium: "text-amber-400 border-amber-400/30",
};
export const Badge = ({ v, testid }) => <span data-testid={testid} className={`inline-block border px-1.5 py-0.5 text-[10px] font-mono uppercase tracking-wider ${TONES[v] || "text-slate-400 border-slate-600"}`}>{String(v)}</span>;
export const Sim = () => <span className="inline-block border border-fuchsia-300/40 text-fuchsia-300 px-1.5 py-0.5 text-[10px] font-mono">SIMULÉ</span>;

export const abtn = "border border-[#1E222D] bg-[#161922] px-3 py-1.5 text-xs font-mono hover:border-emerald-500/50 hover:text-emerald-300 transition-colors disabled:opacity-40";
export const abtnDanger = "border border-red-500/40 text-red-300 px-3 py-1.5 text-xs font-mono hover:bg-red-500/10 transition-colors";
export const ainput = "bg-[#0D0F14] border border-[#1E222D] px-2.5 py-1.5 text-sm font-mono outline-none focus:border-emerald-500/60";

export function Table({ cols, rows, testid, onRow }) {
  return (
    <div className="overflow-x-auto" data-testid={testid}>
      <table className="w-full text-sm">
        <thead><tr className="text-left">{cols.map((c) => <th key={c[0]} className="label-xs pb-3 pr-4 font-normal">{c[0]}</th>)}</tr></thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.id || i} onClick={onRow ? () => onRow(r) : undefined} className={`border-t border-[#1E222D] ${onRow ? "cursor-pointer hover:bg-white/[0.02]" : ""}`}>
              {cols.map((c) => <td key={c[0]} className="py-2.5 pr-4 align-top">{c[1](r)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
      {!rows.length && <div className="text-slate-500 text-sm py-6">Aucune donnée.</div>}
    </div>
  );
}

export const H1 = ({ children, sub }) => <div className="mb-8"><h1 className="text-3xl font-bold tracking-tight">{children}</h1>{sub && <p className="text-sm text-slate-500 mt-2 max-w-3xl">{sub}</p>}</div>;
